import React, {Component} from 'react';
import NewItemModal from '../../Components/Modals/newitemmodals';
import {Nav,NavItem,NavLink} from 'reactstrap';
import {Link} from 'react-router-dom';
import './adminstore.css';


class Adminstore extends Component {
    render() {
        return (
            <div>
                <div className="App-header">
                </div>
                <Nav>
                    <NavItem>
                      <NavLink href="/admin"><Link to="/admin">Admin Home</Link></NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/adminblog"><Link to="/adminblog">Admin Blog</Link></NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/adminstore"><Link to="/adminstore">Admin store</Link></NavLink>
                    </NavItem>
                </Nav>
                <h3>Add a new item for sale</h3>
                pop up model that has item name, item description, amount for sale, quantity available picture able to be uploaded.  
                <NewItemModal
                buttonLabel={'Add Item'}
                />
            </div>
        )
    }
}

export default Adminstore